import { makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles(theme => ({
}));
const ListPaymentMethodsScreen = ({}) => {
  const classes = useStyles()
  return (
    <>src/pages/CustomerBookingCreate/8/Payment/1/ListPaymentMethods/index.jsx</>
  )
}

export {ListPaymentMethodsScreen}